export default function (text: string) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-') // Replace any character that is not a letter, number, or dash with dashes
    .replace(/-+/g, '-') // Replace consecutive dashes with single dash
    .replace(/^-|-$/g, '') // Remove leading and trailing dashes
}
